import { ExclamationCircleFilled } from '@ant-design/icons'
import { Button } from 'antd'

import { getMessage } from '../../../../../../util/IntlMessages'

export function DuplicatedModalAlert({ handleSaveAnyway, handleGoToDuplicate }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center', padding: '10px', gap: '15px' }}>
      <ExclamationCircleFilled style={{ fontSize: 32, color: '#f5222d', marginBottom: 16 }} />

      <div>
        <p style={{ fontSize: '14px' }}>
          <strong style={{ color: '#f5222d' }}>{getMessage('sweetAlerts.attention')}:</strong>{' '}
          {getMessage('duplicateVisit.message1')}
        </p>

        <p style={{ fontSize: '14px' }}>{getMessage('duplicateVisit.message2')}</p>
      </div>

      <div style={{ display: 'flex', marginTop: 5, width: '100%', justifyContent: 'space-between' }}>
        <Button type="default" onClick={handleSaveAnyway} style={{ width: '100%' }}>
          {getMessage('duplicateVisit.confirmSaving')}
        </Button>
        <Button type="primary" style={{ width: '100%' }} key="go" onClick={handleGoToDuplicate}>
          <span style={{ fontSize: '12px' }}>{getMessage('duplicateVisit.goTo')}</span>
        </Button>
      </div>
    </div>
  )
}
